import { APPROVED_STATUS, REJECTED_STATUS } from "../components/select-status-param";

const convertStatus = (status: string) => {
  switch (status) {
    case "Rejected":
      return REJECTED_STATUS;
    case "Approved":
      return APPROVED_STATUS;
  }
};

export default convertStatus;
